import './graph.scss';
import * as d3 from "d3";
import {
    library,
    icon
} from '@fortawesome/fontawesome-svg-core';
import {
    faSearch as faSearchRegular,
    faReply as faReplyRegular
} from '@fortawesome/pro-regular-svg-icons';

library.add(faSearchRegular, faReplyRegular);
//dom.watch();

//let height = 320; //document.documentElement.clientHeight; //680;
//let width = 270; //document.documentElement.clientWidth; //680;
let width = 100;
let height = 100;


let minDimension = Math.min(width, height);
let radiusScale = 2;

let svgHeight = window.innerHeight - 30;
let svgWidth = document.documentElement.clientWidth - 30;
let scaleRatio = svgHeight / height;

let el = document.getElementById('data');
let data = JSON.parse(el.dataset.graph);
let l10n = JSON.parse(el.dataset.l10n);
let currentTransform = [width / 2, height / 2, height];

let roots = [];

const iconSearch = icon({
    prefix: 'far',
    iconName: 'search'
});
const iconBack = icon({
    prefix: 'far',
    iconName: 'reply'
});

let drag = simulation => {

    function dragstarted(d) {
        if (!d3.event.active) simulation.alphaTarget(0.3).restart();
        d.fx = d.x;
        d.fy = d.y;
    }

    function dragged(d) {
        d.fx = d3.event.x;
        d.fy = d3.event.y;
    }

    function dragended(d) {
        if (!d3.event.active) simulation.alphaTarget(0);
        d.fx = null;
        d.fy = null;
    }

    return d3.drag()
        .on("start", dragstarted)
        .on("drag", dragged)
        .on("end", dragended);
};

const infoBox = d3.select(".info-box");

const svg = d3.create("svg")
    .attr("width", svgWidth)
    .attr("height", svgHeight)
    .attr("preserveAspectRatio", "xMidYMid meet")
    .attr("viewBox", [-width / 2, -height / 2, width, height]);

const g = svg.append("g");
const dummy = svg.append("rect");


function create(g, n, l) {
    const links = l.map(d => Object.create(d));
    const nodes = n.map(d => Object.create(d));
    const max = l.length ? l.reduce((prev, current) => (prev.value > current.value) ? prev : current) : 0;

    let shouldZoom = true;

    let color = d => {
        let normalized = d.id / nodes.length;
        //return d3.interpolatePuBu(normalized);
        return d3.interpolateOrRd(normalized);
    };

    let fgColor = d => {
        let normalized = d.id / nodes.length;
        if (normalized > 0.3 && normalized <= 0.5) {
            normalized = 0.3;
        }
        if (normalized < 0.7 && normalized >= 0.5) {
            normalized = 0.7;
        }
        return d3.interpolateGreys(1 - normalized);
    };

    const simulation = d3.forceSimulation(nodes)
        //  .alphaMin(0.5)
        .force("link", d3.forceLink(links).id(d => d.id).distance(d => {
            let min = Math.floor(parseFloat(d.source.radius) + parseFloat(d.target.radius));
            // min = d.source.count + d.target.count;
            let s = d3.scaleLog([1, max.value], [width / 2, min * 2]);
            //let max = width / 2;
            return s(d.value); //max.value * min / d.value; 
        }))
        .force("charge", d3.forceManyBody().distanceMax(2 * minDimension))
        .force('collide', d3.forceCollide().radius(d => d.radius))
        .force("x", d3.forceX())
        .force("y", d3.forceY());

    const link = g.append("g")
        .attr("stroke", "#999")
        .attr("stroke-opacity", 0.6)
        .selectAll("line")
        .data(links)
        .join("line")
        .attr("stroke-width", d => Math.sqrt(d.value));

    const node = g.append("g")
        .attr("stroke", "#fff")
        .attr("stroke-opacity", 0.6)
        .attr("stroke-width", 0.2)
        .selectAll("g")
        .data(nodes)
        .join("g")
        .attr("class", 'node-container');

    node.append("circle").attr("r", d => d.radius)
        //.attr("stroke", "#999")
        .attr("stroke-opacity", 1)
        .attr("stroke-width", 0.4)
        .attr("fill", color);

    const nodeTitles = node.append("text")
        .attr("fill", fgColor)
        .each(function (d) {
            let el = d3.select(this);
            console.log(el);
            let words = d.name.split(/\s+/);
            //if (words.length > 3) {
            if (d.name.length > 23) {
                let sep = Math.ceil(words.length / 2);
                el.append('tspan').attr('dy', '-1em').text(words.slice(0, sep).join(' '));
                el.append('tspan').attr('dy', '1em').attr('x', 0).text(words.slice(sep).join(' '));
            } else {
                el.text(d.name);
            }
        });

    node.call(drag(simulation));

    node.append("title")
        .text(d => d.name);

    node.append("a")
        .attr('href', '#')
        .attr("class", 'zoom-in')
        .on('click', function (d) {
            return transition(this, d);
        })
        .append("text")
        .text("+")
        .attr("transform", d => {
            let length = 20;
            let scale = d.radius / length;
            return `
                scale(${scale})
                translate(${-length / 4}, ${15})
                `;
        });

    let lastAlpha = 0;
    simulation.on("tick", () => {
        link
            .attr("x1", d => d.source.x)
            .attr("y1", d => d.source.y)
            .attr("x2", d => d.target.x)
            .attr("y2", d => d.target.y);

        node.attr("transform", d => {
            return `
            translate(${d.x}, ${d.y})
        `;
        });
        let alpha = simulation.alpha();
        if (alpha < 0.6 && shouldZoom) {
            lastAlpha = alpha;
            shouldZoom = false;
            lapsedZoomFit(350);
        }
    });

    return nodeTitles;
}


//invalidation.then(() => simulation.stop());

function transition(el, d) {
    d3.event.stopPropagation();
    d3.event.preventDefault();
    let setInfo = true;
    let zoomIn = true;

    // console.log(el);

    let pNode = el.parentNode;
    let aNode = pNode.parentNode.closest('.node-container');

    if (!d) {
        roots.pop();
        zoomIn = false;
        d = {
            x: 0,
            y: 0,
            radius: width / radiusScale,
            radiusY: height / radiusScale
            //radius: minDimension / 2
        };
        pNode.querySelectorAll('circle').forEach(e => {
            e.classList.remove('selected')
        });
        pNode.parentNode.querySelectorAll('.zoomed').forEach(e => {
            e.classList.remove('zoomed');
        });
        pNode.classList.remove('selected-node');

        if (!aNode) {
            infoBox.node().classList.add('d-none');
            setInfo = false;
            d3.select(pNode).select('g').remove();
        } else {
            pNode = aNode;
        }
    } else {
        roots.push(pNode);
        if (!aNode) {
            pNode.querySelectorAll('text').forEach(e => {
                e.classList.add('d-none')
            });
        }
        document.querySelectorAll('.zoom-in').forEach(e => {
            e.classList.add('d-none')
        });
        pNode.querySelectorAll('circle').forEach(e => {
            e.classList.add('selected')
        });

        /*
                console.log(svg.selectAll("g.node-container"));
                svg.selectAll("g.node-container").sort(function (a, b) {
                    //console.log(a);

                    if (a.index != pNode.index) {
                        return -1;
                    }
                    else {
                        return 1;
                    }
                }); */
    }
    //    console.log(d.radius);
    // let radius = d.radius * 3;
    let radius = d.radius * radiusScale;
    let x = d.x + radius / 2;
    let y = d.y + radius / 2;
    if (!!d.radiusY) {
        y = d.y + d.radiusY * radiusScale / 2;
    }

    let pid = null;
    if (!!aNode) {
        let aDatum = d3.select(aNode).datum();
        if (zoomIn) {
            const scale = 2 / scaleRatio;
            pid = aDatum.id;
            radius = radius * scale;

            x = d.x * scale + aDatum.x;
            y = d.y * scale + aDatum.y;

            x += radius / 2;
            y += radius / 2;
        } else {
            radius = aDatum.radius * radiusScale;
            x = aDatum.x + radius / 2;
            y = aDatum.y + radius / 2;
        }
    }

    // const i = d3.interpolateZoom(currentTransform, [x, y, radius]);

    let bounds = zoomFit();
    svg.transition()
        .delay(450)
        .attr('viewBox', `${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`)
        // g.transition()
        //   .delay(250)
        // .attr()
        //  .duration(i.duration)
        //  .attrTween("transform", () => t => transform(currentTransform = i(t)))
        .on("end", () => {
            if (setInfo) {
                info(pNode, pid);
            }

            if (zoomIn) {
                document.querySelectorAll('g.node-container').forEach(e => {
                    e.classList.add('zoomed');
                });
                pNode.classList.add('selected-node');
                showChildren(pNode);
            } else {
                el.parentNode.querySelectorAll('text').forEach(e => {
                    e.classList.remove('d-none')
                });
                el.parentNode.parentNode.querySelectorAll('.zoom-in').forEach(e => {
                    e.classList.remove('d-none')
                });
            }
        });

}

function transform([x, y, r]) {
    return `
          translate(${width / 2}, ${height / 2})
          scale(${width / r})
          translate(${-x}, ${-y})
        `;
}

function info(el, pid) {
    let datum = d3.select(el).datum();

    let baseUrl = 'search?Search[0][and][0][f]=Technologies.id&Search[0][and][0][q]=';
    if (!!pid) {
        baseUrl += pid + '&Search[0][and][1][f]=Audiences.id&Search[0][and][1][q]=';
    }
    infoBox.node().classList.remove('d-none');
    infoBox.style('top', '0px');
    infoBox.style('left', '0px');
    infoBox.select('.info-box-title').text(datum.name);
    infoBox.select('.info-box-count').text(l10n.count + " " + datum.count);
    let infoBoxLink = infoBox.select('.info-box-link').selectAll('a').data([datum], d => d.id).join("a").attr('href', d => baseUrl + d.id).attr('class', 'btn btn-primary btn-block');
    infoBoxLink.append('svg').attr('width', 16).attr('height', 16).html(iconSearch.html);
    infoBoxLink.append('span').text(l10n.consult);

    let infoBoxQuit = infoBox.select('.info-box-back').selectAll('a').data([datum], d => d.id).join("a").attr('href', '#').attr('class', 'btn btn-secondary btn-block').on('click', function (d) {
        infoBoxLink.remove();
        infoBoxQuit.remove();
        return transition(el.getElementsByTagName("a")[0]);
    });
    infoBoxQuit.append('svg').attr('width', 16).attr('height', 16).html(iconBack.html);
    infoBoxQuit.append('span').text(l10n.back);
}

function showChildren(el) {
    let g = d3.select(el);

    let data = g.datum();

    if (!data.nodes) {
        return;
    }

    let container = g.append('g').attr("transform", d => {
        return `scale(${ 0.25 })`; // TODO: why 2 ?
        //return `scale(${ 3 / scaleRatio })`; // TODO: why 2 ?
    });
    let nodeTitles = create(container, data.nodes, data.links);

    nodeTitles.each(titleSize);

}

d3.select(window).on('resize', resize);

function resize() {
    svgHeight = window.innerHeight - 30;
    svgWidth = document.documentElement.clientWidth - 30;
    svg.attr("width", svgWidth)
        .attr("height", svgHeight);

    lapsedZoomFit(0);
}

function lapsedZoomFit(transitionDuration) {
    let bounds = zoomFit();

    svg.transition()
        .delay(transitionDuration)
        .attr('viewBox', `${bounds.x} ${bounds.y} ${bounds.width} ${bounds.height}`);
}

function zoomFit() {
    let paddingPercent = 0.9;
    // console.log(roots);
    let root = roots[roots.length - 1];
    let bounds = root.getBBox();

    // console.log(bounds);

    let transf = root.transform.baseVal.consolidate();
    if (!!transf) {
        let matrix = transf.matrix;

        let p3 = root.parentNode.closest('.node-container');
        if (!!p3) {
            let t3 = p3.transform.baseVal.consolidate();
            let p2 = root.parentNode.closest('g[transform]');
            if (!!p2) {
                let t2 = p2.transform.baseVal.consolidate();
                matrix = t3.matrix.multiply(t2.matrix).multiply(matrix);
                // console.log(matrix);
            }
        }
        let newX1 = matrix.a * bounds.x + matrix.c * bounds.y + matrix.e;
        let newY1 = matrix.b * bounds.x + matrix.d * bounds.y + matrix.f;

        //   let newX2 = a * (bounds.x + bounds.width) + c * bounds.y + e;
        //   let newY2 = b * (bounds.x + bounds.width) + d * bounds.y + f;

        //   let newX3 = a * bounds.x + c * (bounds.y + bounds.height) + e;
        //   let newY3 = b * bounds.x + d * (bounds.y + bounds.height) + f;

        let newX4 = matrix.a * (bounds.x + bounds.width) + matrix.c * (bounds.y + bounds.height) + matrix.e;
        let newY4 = matrix.b * (bounds.x + bounds.width) + matrix.d * (bounds.y + bounds.height) + matrix.f;

        //  console.log(newX1, newY1);
        //  console.log(newX4, newY4);

        bounds.x = newX1;
        bounds.y = newY1;

        bounds.width = newX4 - newX1;
        bounds.height = newY4 - newY1;
        //bounds.x = transf.matrix.e;
        //bounds.y += transf.matrix.f;
        //console.log(transf.matrix);
    }

    return bounds;
    /*
    	var parent = root.node().parentElement;
    	var fullWidth = parent.clientWidth,
    	    fullHeight = parent.clientHeight;
    	var width = bounds.width,
    	    height = bounds.height;
    	var midX = bounds.x + width / 2,
    	    midY = bounds.y + height / 2;
    	if (width == 0 || height == 0) return; // nothing to fit
    	var scale = (paddingPercent || 0.75) / Math.max(width / fullWidth, height / fullHeight);
    	var translate = [fullWidth / 2 - scale * midX, fullHeight / 2 - scale * midY];

    	//console.trace("zoomFit", translate, scale);

        root.attr('transform',
            `translate(${translate[0]}, ${translate[1]})
             scale(${scale})`);
        /*     
        ${width / 2}, ${height / 2}
        'translate(' + d3.event.translate + ')'
        +   'scale(' + d3.event.scale     + ')');
        var transform = d3.zoomIdentity
            .translate(translate[0], translate[1])
            .scale(scale);

        root
            .transition()
            .duration(transitionDuration || 0) // milliseconds
            .call(zoomer.transform, transform); */
}

let titleSize = function (d) {
    let text = d3.select(this);
    let length = text.node().getBBox().width; //text.node().getComputedTextLength();
    let scale = d.radius * 1.5 / length;
    let ty = 0;
    if (scale > 1.5) {
        scale = 1.5;
        ty = scale * 5;
    }
/*    if (scale < 0.1) {
        wrap(text, {x:0, y:0}, text.node().parentNode);
    } */
    text.attr("transform", d => {
        return `
                scale(${scale})
                translate(${-length / 2}, ${ty})
            `;
    });
};

/*
function wrap(text, offset, el) {
    let width = el.getBBox().width;
    let total_dy = 0;
    text.each(function (d) {
        var text = d3.select(this),
            words = text.text().split(/\s+/).reverse(),
            word,
            line = [],
            lineHeight = 1.1, // ems
            y = 0, //text.attr("y"),
            dy = 1, //parseFloat(text.attr("dy")),
            tspan = text.text(null).append("tspan").attr("x", 0).attr("y", 0).attr("dy", dy + "em");
        total_dy = dy;
        while (word = words.pop()) {
            line.push(word);
            tspan.text(line.join(" "));
            if (tspan.node().getComputedTextLength() > width) {
                line.pop();
                tspan.text(line.join(" "));
                line = [word];
                tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", lineHeight + "em").text(word);
                total_dy += lineHeight;
            }
        }
        total_dy += lineHeight;
    });
    offset.y = total_dy;
} */

let nodeTitles = create(g, data.nodes, data.links);
roots.push(g.node());


el.append(svg.node());
//el.append(infoBox.node());
nodeTitles.each(titleSize);
/*
svg.call(d3.zoom()
    .extent([
        [0, 0],
        [width, height]
    ])
    .scaleExtent([1, 8])
    .on("zoom", zoomed));

function zoomed(
) {
    console.log(d3.event.transform);
   // svg.attr("viewBox", d3.event.transform);
}
*/
